import apiAction from 'common/redux/actions/apiAction';
import {
    POST_ADMINVIEW_NON_COMPLIANT_URL,
    POST_ADMINVIEW_AT_RISK_URL,
} from './apiPathConstants';
import { logError } from 'TAP/utils/commonMethods';

const getAdminNonCompliantData = data => {
  return {
    type: 'GET_ADMIN_NON_COMPLIANT_DATA',
    payload: data,
  };
};

export const AdminNonCompliantData = configParams => {
  return apiAction.postAPI({
    url: POST_ADMINVIEW_NON_COMPLIANT_URL(),
    data: configParams,
    onSuccess: getAdminNonCompliantData,
    onFailure: err => logError('Error occured in fetching dashboard data.:', err),
    label: 'FETCH_ADMIN_NON_COMPLIANT_DATA',
  });
};
const getAdminAtRiskData = data => {
  return {
    type: 'GET_ADMIN_AT_RISK_DATA',
    payload: data,
  };
};

export const AdminAtRiskData = configParams => {
  return apiAction.postAPI({
    url: POST_ADMINVIEW_AT_RISK_URL(),
    data: configParams,
    onSuccess: getAdminAtRiskData,
    onFailure: err => logError('Error occured in fetching dashboard data.:', err),
    label: 'FETCH_ADMIN_AT_RISK_DATA',
  });
};
